import React from 'react';
import classnames from 'classnames/bind';

import { UserGroup } from 'types/user_group';

import { useUserGroups } from 'settings/hooks/useUserGroups';

import * as PageLayout from 'components/PageLayout';
import { Button } from 'components/Button/Button';
import { ExternalLink } from 'components/ExternalLink/ExternalLink';
import { Heading } from 'components/Heading/Heading';
import { Text } from 'components/Text/Text';

import { UserGroupsTable } from '../Members/components/Table/UserGroupsTable/UserGroupsTable';
import { UserGroupForm } from '../Members/components/UserGroupForm/UserGroupForm';
import styles from '../Members/Members.module.scss';

const c = classnames.bind(styles);

const PAGE_SIZE = 10;

export function UserGroups() {
  const [page, setPage] = React.useState(1);
  const [isFormOpen, setIsFormOpen] = React.useState(false);
  const [editingGroup, setEditingGroup] = React.useState<UserGroup>();

  const queryResult = useUserGroups({
    params: { page, limit: PAGE_SIZE },
    keepPreviousData: true,
  });

  const handleEdit = React.useCallback((group: UserGroup) => {
    setEditingGroup(group);
    setIsFormOpen(true);
  }, []);

  const handleCreate = React.useCallback(() => {
    setEditingGroup(undefined);
    setIsFormOpen(true);
  }, []);

  function handleFormClose() {
    setIsFormOpen(false);
    setEditingGroup(undefined);
  }

  return (
    <PageLayout.Root size="medium">
      <PageLayout.Container>
        <div className={c('wrap')}>
          <div className={c('header')}>
            <div>
              <Heading level="2">Workspace member groups</Heading>
              <ExternalLink href="https://docs.lumeo.com/docs/groups">
                Groups docs
              </ExternalLink>
              <Text>
                Create member groups to route notifications to the right people.
              </Text>
            </div>

            <Button variant="secondary" size="small" onClick={handleCreate}>
              Create group
            </Button>
          </div>

          <UserGroupsTable
            queryResult={queryResult}
            pageSize={PAGE_SIZE}
            page={page}
            onPageChange={setPage}
            onEdit={handleEdit}
          />
        </div>

        <UserGroupForm
          open={isFormOpen}
          onClose={handleFormClose}
          group={editingGroup}
        />
      </PageLayout.Container>
    </PageLayout.Root>
  );
}
